export default {
      id: "logo_grand_site-usage",
      viewBox: "0 0 168 60",
      url: "../dist/images/" + "sprite.svg#logo_grand_site-usage",
      toString: function () {
        return this.url;
      }
    }